import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";
import useJsonLd from "../../hooks/useJsonLd";

/* ─────────── DATA ─────────── */
const daySchools = [
  {
    name: "Sutton Park School（サットン・パーク・スクール）",
    nameNote: "",
    location: "ダブリン北部（海沿い）",
    type: "インターナショナル共学校",
    features: ["ICT教育の先駆者", "CIS/NEASC国際認定", "国際色豊かな環境"],
    tokuchou: "ダブリン北部の海沿いにある、リベラルで国際色豊かな共学校。",
    kyouiku: "ICT（情報通信技術）教育の先駆者であり、最新設備を使った授業が特徴。欧米の国際認定（CIS/NEASC）を受けており、教育の質が保証されています。",
    fee: "€24,450",
    note: "最新設備と国際認定の質が保証",
    highlight: false,
    img: "https://storage.readdy-site.link/project_files/4c258df0-4795-43d0-92fa-ad229c3fae38/30257d00-73d9-488c-b8bc-16f1bf46cd75_1664_20240611101042.jpeg?v=c7870297d6d46d53926aa29467e2690a",
    objectPosition: "center 35%",
  },
  {
    name: "John Scottus School（ジョン・スコタス・スクール）",
    nameNote: "",
    location: "ダブリン",
    type: "私立デイスクール",
    features: ["哲学・マインドフルネス教育", "少人数制で個性を大切に", "深い思考力を養う"],
    tokuchou: "哲学やマインドフルネスを教育の柱に据えたユニークな学校。",
    kyouiku: "伝統的な科目に加え、瞑想や哲学を学ぶことで、ストレス管理能力や深い思考力を養います。少人数制で一人ひとりの個性を大切にします。",
    fee: "€22,150",
    note: "ユニークな教育哲学が魅力",
    highlight: true,
    img: "https://storage.readdy-site.link/project_files/4c258df0-4795-43d0-92fa-ad229c3fae38/80b0aa1c-f4aa-417c-be51-b9569347c6a2_489024834_18321387736207480_8719043583036195220_n.jpg?v=4d453b48e29703604dbdbceb91de17e9",
    objectPosition: "center top",
  },
  {
    name: "St Conleth's College（セント・コンレス・カレッジ）",
    nameNote: "",
    location: "ダブリン市内近く",
    type: "私立共学校",
    features: ["ディベートの強豪校", "知的好奇心を刺激する教育", "自己表現力を育む"],
    tokuchou: "ダブリン中心部に近い、活気あふれる共学校。",
    kyouiku: "「ディベート」の強豪校として有名。生徒の知的好奇心を刺激し、自信を持って自分の意見を発信できる力を育てます。",
    fee: "€23,150",
    note: "論理的思考と発信力を磨ける",
    highlight: false,
    img: "https://storage.readdy-site.link/project_files/4c258df0-4795-43d0-92fa-ad229c3fae38/08f83710-9477-40dd-9705-165581ae2a23_St-Conleths-College.jpg?v=009184e9f5392d270bfac99076c22581",
    objectPosition: "center 35%",
  },
];

const boardingSchools = [
  {
    name: "The King's Hospital（キングス・ホスピタル）",
    nameNote: "",
    location: "ダブリン近郊",
    type: "全寮制・共学",
    features: ["1669年創立の名門校", "80エーカーの広大な施設", "留学生受け入れ体制が充実"],
    tokuchou: "1669年創立、ダブリン近郊。アイルランドで最も歴史と権威のある学校の一つです。",
    kyouiku: "広大な80エーカーの敷地に最新のスポーツ施設や芸術ホールを完備。24時間体制のケアがあり、留学生の受け入れ体制が非常に強固です。",
    fee: "€38,175",
    note: "歴史と権威を誇るダブリン最高峰の全寮制",
    highlight: true,
    img: "https://storage.readdy-site.link/project_files/4c258df0-4795-43d0-92fa-ad229c3fae38/24ebb359-0427-4200-b51f-c65b8ef9c820_-2026-03-19-22.39.33.png?v=41efc9918fcac23dd96bf63c0a095a05",
    objectPosition: "center top",
  },
  {
    name: "Rockwell College（ロックウェル・カレッジ）",
    nameNote: "",
    location: "ティペラリー州",
    type: "全寮制・共学",
    features: ["ラグビー強豪校として世界的に有名", "強力な卒業生ネットワーク", "リーダーシップを育む規律"],
    tokuchou: "ティペラリー州にある、ラグビーの強豪として世界的に有名なカトリック系名門校。",
    kyouiku: "卒業生のネットワークが非常に強く、世界中で活躍するOB・OGを輩出しています。規律ある生活の中で、リーダーシップを育む環境です。",
    fee: "€33,725",
    note: "世界で活躍するOB・OGを輩出する名門",
    highlight: false,
    img: "https://storage.readdy-site.link/project_files/4c258df0-4795-43d0-92fa-ad229c3fae38/312452f9-c03b-4af8-8d72-e81b8b5fd00a_-2026-03-19-22.42.03.png?v=dc49ea095cab152475fb90ba0503fad6",
    objectPosition: "center top",
  },
  {
    name: "Villiers School（ヴィリアーズ・スクール）",
    nameNote: "",
    location: "リムリック",
    type: "寄宿・共学",
    features: ["IB認定校（アイルランド2校のみ）", "IBDP提供・海外大学進学に最適", "多様性を重視するプロテスタント系"],
    tokuchou: "リムリックに位置する、アイルランドでわずか2校しかない国際バカロレア（IB）認定校。",
    kyouiku: "多様性を重視するプロテスタント系の共学校。世界水準の教育カリキュラム（IBDP）を提供しており、海外大学への進学を視野に入れる生徒に最適です。",
    fee: "€36,075〜€40,875",
    note: "IBディプロマで世界の大学へ",
    highlight: false,
    img: "https://storage.readdy-site.link/project_files/4c258df0-4795-43d0-92fa-ad229c3fae38/a97bf484-5917-4ce2-bb6a-fc8639211bf8_-2026-03-19-22.43.10.png?v=3e0d67ed52a14433f0a0c3321658efb0",
    objectPosition: "center top",
  },
];

const timeline = [
  { step: "01", title: "ClassLive留学へ無料相談", desc: "まずはClassLive留学のカウンセラーへご連絡ください。ニーズ・英語レベル・予算・期間をヒアリングし、お子様に最適な学校・プログラムをご提案します。LINEでのご相談も歓迎です。", icon: "ri-chat-smile-2-line" },
  { step: "02", title: "学校提案", desc: "カウンセラーより最適な学校を複数ご提案。TY・シニアサイクルなどプログラムも一緒に検討します。", icon: "ri-school-line" },
  { step: "03", title: "現地担当者との面談", desc: "詳細確認・プロファイル作成。現地スタッフが直接ご家族と話し合い、留学プランを固めます。", icon: "ri-discuss-line" },
  { step: "04", title: "学校選考・出願", desc: "書類提出、学校との面談・テスト（学校による）。不合格の場合は即座に別の学校を提案します。", icon: "ri-file-list-3-line" },
  { step: "05", title: "デポジット支払い", desc: "費用の30%をお支払いいただき、席を確保します。人気校は早期に満席になるため、早めの手続きを推奨します。", icon: "ri-secure-payment-line" },
  { step: "06", title: "入学決定・科目選択", desc: "現地担当者のアドバイスのもと履修科目を決定。TYは体験活動、シニアサイクルはLeaving Certの科目を選択します。", icon: "ri-book-open-line" },
  { step: "07", title: "滞在先決定", desc: "ホームステイまたは寮を確定。学校への通学圏内（徒歩またはバス30分）を最優先に配置します。", icon: "ri-home-heart-line" },
  { step: "08", title: "渡航準備", desc: "航空券手配・保険加入・残金（70%）のお支払い。制服・教科書は現地スタッフが購入をサポートします。", icon: "ri-suitcase-2-line" },
  { step: "09", title: "渡航・到着", desc: "現地スタッフが空港でお出迎え。ホームステイ先または寮までの送迎・オリエンテーションを実施します。", icon: "ri-flight-takeoff-line" },
  { step: "10", title: "留学スタート！", desc: "最初の4週間は毎週ガーディアン（現地担当者）と面談。ClassLive留学スタッフとはLINEでいつでも連絡可能。毎月のウェルフェアレポートで保護者様にもお子様の様子をお伝えします。", icon: "ri-graduation-cap-line" },
];

const faqs = [
  { q: "英語が全然できなくても大丈夫ですか？", a: "TY（トランジションイヤー）からのスタートであれば、英語力が低くても参加可能です。勉強よりも体験重視なので、現場で英語を自然に伸ばせます。シニアサイクルの場合は中級レベル（B1・英検2級程度）以上が推奨されます。" },
  { q: "1年だけの留学はできますか？", a: "可能です。ただし、1学期（ターム）だけの短期留学を受け入れている学校は少ないため、基本的には「1年間（3学期）」単位での申込みをお勧めしています。" },
  { q: "年末年始（クリスマス）はどうなりますか？", a: "12/21〜1/4のクリスマス休暇は費用に含まれておらず、寮も閉まることが多いため、原則一時帰国となります。現地滞在を強く希望する場合は追加手配が必要ですが、食事が出ないなどの制約があります。" },
  { q: "ホームステイ先は選べますか？", a: "「ペットなし」「子供がいる家庭」などのリクエストは出せますが、確約はできません。学校への通学圏内（徒歩またはバス30分）を最優先に配置されます。" },
  { q: "入学テストで落ちたらどうなりますか？", a: "すぐに別の空きのある学校を探して提案します。全員が入学できるようサポートしますのでご安心ください。" },
  { q: "子どもが現地でトラブルに遭ったら？", a: "現地のガーディアン（教育後見人スタッフ）が24時間体制で対応します。日本語対応のClassLive留学スタッフとも連携しているため、保護者様にも日本語で迅速にご連絡します。" },
  { q: "夏休みは現地に残れますか？", a: "6月〜8月は夏休み期間で学校も寮も閉まります。プログラム期間外となるため、原則帰国となります。" },
  { q: "ビザ申請は必要ですか？", a: "日本国籍の場合、事前のビザ申請は不要です。現地到着後に外国人登録（IRP）を行い、滞在許可を得ます。現地スタッフがこの手続きを全面的にサポートします。入国審査時には「未成年者渡航同意書（親の署名原本）」が必須です。" },
  { q: "費用に何が含まれていますか？", a: "授業料・滞在費（食事付き）・ガーディアン費用・空港送迎が含まれます。航空券・保険・制服・教科書・クリスマス休暇滞在費は別途必要です。" },
];

/* ─────────── COMPONENT ─────────── */
export default function HighSchoolPage() {
  const [openFaq, setOpenFaq] = useState<number | null>(null);
  const [schoolTab, setSchoolTab] = useState<"day" | "boarding">("day");
  const siteUrl = import.meta.env.VITE_SITE_URL ?? "https://example.com";

  useEffect(() => {
    document.title = "アイルランド高校留学 | TY・全寮制・語学プログラム | ClassLive留学";
    const desc = document.querySelector('meta[name="description"]');
    if (desc) desc.setAttribute("content", "アイルランドの高校留学なら15校以上の提携校から最適な学校を無料でご提案。TY・シニアサイクル・全寮制など多彩なプログラム。世界平和度指数2位の安全な国で本格英語留学を。");
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) canonical.setAttribute("href", `${siteUrl}/high-school`);
  }, [siteUrl]);

  useJsonLd({
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Service",
        "name": "アイルランド高校留学プログラム",
        "description": "アイルランドへの高校留学サポートサービス。15校以上の提携校からTY・シニアサイクル・全寮制など最適なプログラムをご提案。無料カウンセリング実施中。",
        "provider": {
          "@type": "Organization",
          "name": "ClassLive留学アイルランド",
          "url": siteUrl
        },
        "serviceType": "高校留学サポート",
        "areaServed": "JP",
        "url": `${siteUrl}/high-school`,
        "offers": {
          "@type": "Offer",
          "price": "0",
          "priceCurrency": "JPY",
          "description": "無料カウンセリング・手続きサポート"
        }
      },
      {
        "@type": "FAQPage",
        "name": "アイルランド高校留学 よくある質問",
        "url": `${siteUrl}/high-school`,
        "mainEntity": [
          {
            "@type": "Question",
            "name": "英語が全然できなくても大丈夫ですか？",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "TY（トランジションイヤー）からのスタートであれば、英語力が低くても参加可能です。勉強よりも体験重視なので、現場で英語を自然に伸ばせます。シニアサイクルの場合は中級レベル（B1・英検2級程度）以上が推奨されます。"
            }
          },
          {
            "@type": "Question",
            "name": "1年だけの留学はできますか？",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "可能です。ただし、1学期（ターム）だけの短期留学を受け入れている学校は少ないため、基本的には「1年間（3学期）」単位での申込みをお勧めしています。"
            }
          },
          {
            "@type": "Question",
            "name": "年末年始（クリスマス）はどうなりますか？",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "12/21〜1/4のクリスマス休暇は費用に含まれておらず、寮も閉まることが多いため、原則一時帰国となります。現地滞在を強く希望する場合は追加手配が必要ですが、食事が出ないなどの制約があります。"
            }
          },
          {
            "@type": "Question",
            "name": "ホームステイ先は選べますか？",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "「ペットなし」「子供がいる家庭」などのリクエストは出せますが、確約はできません。学校への通学圏内（徒歩またはバス30分）を最優先に配置されます。"
            }
          },
          {
            "@type": "Question",
            "name": "入学テストで落ちたらどうなりますか？",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "すぐに別の空きのある学校を探して提案します。全員が入学できるようサポートしますのでご安心ください。"
            }
          },
          {
            "@type": "Question",
            "name": "子どもが現地でトラブルに遭ったら？",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "現地のガーディアン（教育後見人スタッフ）が24時間体制で対応します。日本語対応のClassLive留学スタッフとも連携しているため、保護者様にも日本語で迅速にご連絡します。"
            }
          },
          {
            "@type": "Question",
            "name": "夏休みは現地に残れますか？",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "6月〜8月は夏休み期間で学校も寮も閉まります。プログラム期間外となるため、原則帰国となります。"
            }
          },
          {
            "@type": "Question",
            "name": "ビザ申請は必要ですか？",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "日本国籍の場合、事前のビザ申請は不要です。現地到着後に外国人登録（IRP）を行い、滞在許可を得ます。現地スタッフがこの手続きを全面的にサポートします。入国審査時には「未成年者渡航同意書（親の署名原本）」が必須です。"
            }
          },
          {
            "@type": "Question",
            "name": "費用に何が含まれていますか？",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "授業料・滞在費（食事付き）・ガーディアン費用・空港送迎が含まれます。航空券・保険・制服・教科書・クリスマス休暇滞在費は別途必要です。"
            }
          }
        ]
      }
    ]
  } as Record<string, unknown>);

  return (
    <div className="min-h-screen bg-white" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
      <Navbar />

      {/* ── HERO ── */}
      <section className="relative w-full min-h-[70vh] flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0 w-full h-full">
          <img
            src="https://public.readdy.ai/ai/img_res/398c782d3fd9b5f89348357a4e7df1c5.jpg"
            alt="アイルランド高校留学"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/35 to-black/65" />
        </div>
        <div className="relative z-10 w-full text-center px-4 py-28">
          <div className="flex items-center justify-center gap-2 mb-4">
            <Link to="/" className="text-emerald-300 text-sm hover:text-white transition-colors cursor-pointer">ホーム</Link>
            <span className="text-white/40 text-sm">/</span>
            <span className="text-white text-sm">高校留学</span>
          </div>
          <div className="inline-block bg-emerald-600/80 text-white text-xs font-semibold px-4 py-1.5 rounded-full mb-5 tracking-widest">
            🎒 HIGH SCHOOL STUDY ABROAD — ClassLive留学 公式プログラム
          </div>
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4 leading-tight" style={{ fontFamily: "'Noto Serif JP', serif" }}>
            アイルランドで<br />高校留学という選択
          </h1>
          <p className="text-lg text-white/85 max-w-2xl mx-auto mb-3">
            日本人が少ない「英語漬け」の環境・世界平和度指数<strong className="text-emerald-300">2位</strong>の安全な国・<strong className="text-emerald-300">15校＋</strong>の提携校から選べる本格プログラム
          </p>
          <div className="flex items-center justify-center gap-6 text-sm text-white/70 mb-8">
            <span>✦ 対象：15〜18歳</span>
            <span>✦ 期間：1学期〜3年間</span>
            <span>✦ 入学：毎年9月</span>
          </div>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="https://lstep.app/N5D3BZr"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-2 bg-[#06C755] hover:bg-[#05b34c] text-white font-bold px-8 py-4 rounded-full transition-all cursor-pointer whitespace-nowrap shadow-lg"
            >
              <i className="ri-line-line text-xl" />
              LINEで相談する
            </a>
            <Link
              to="/counseling"
              className="inline-flex items-center justify-center gap-2 bg-emerald-500 hover:bg-emerald-400 text-white font-bold px-8 py-4 rounded-full transition-all cursor-pointer whitespace-nowrap shadow-lg"
            >
              <i className="ri-calendar-check-line text-xl" />
              無料カウンセリング予約
            </Link>
          </div>
        </div>
      </section>

      {/* ── STATS BAR ── */}
      <section className="bg-emerald-700 py-5">
        <div className="max-w-5xl mx-auto px-6">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-center">
            {[
              { num: "世界2位", label: "平和度指数（GPI）" },
              { num: "世界3位", label: "一人当たりGDP" },
              { num: "15校＋", label: "提携高校数" },
              { num: "EU唯一", label: "英語公用語国" },
            ].map((s, i) => (
              <div key={i} className="text-white">
                <div className="text-2xl font-bold">{s.num}</div>
                <div className="text-emerald-200 text-xs mt-0.5">{s.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── CLASSLIVE SERVICE ── */}
      <section className="py-20 bg-white">
        <div className="max-w-5xl mx-auto px-6">
          <div className="text-center mb-12">
            <span className="text-emerald-600 text-sm font-semibold tracking-widest uppercase">ClassLive留学とは</span>
            <h2 className="text-3xl font-bold text-gray-800 mt-2" style={{ fontFamily: "'Noto Serif JP', serif" }}>
              日本語でまるごとサポートする<br />留学エージェント
            </h2>
            <p className="text-gray-500 text-sm mt-3 max-w-xl mx-auto">
              ClassLive留学は、出発前の準備から現地での生活まで、日本語で一貫してサポートする留学エージェントです。<strong className="text-emerald-700">ご相談・手続きサポートはすべて無料</strong>です。
            </p>
          </div>

          {/* ClassLive strengths */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mb-12">
            {[
              {
                icon: "ri-customer-service-2-line",
                title: "日本語で安心の無料カウンセリング",
                body: "英語が不安な保護者・生徒の方も安心。日本語で学校選び・費用・プランのご相談をすべて無料で承ります。まずは気軽にLINEやメールでご連絡ください。",
                color: "bg-emerald-100 text-emerald-600",
                badge: "完全無料",
              },
              {
                icon: "ri-line-fill",
                title: "LINEで気軽に日本語相談",
                body: "留学前の疑問から現地での悩みまで、LINEで日本語のまま相談できます。「こんなこと聞いていいの？」という小さな不安もお気軽にどうぞ。",
                color: "bg-teal-100 text-teal-600",
                badge: "LINE対応",
              },
              {
                icon: "ri-user-location-line",
                title: "ヨーロッパ現地スタッフが対応",
                body: "ヨーロッパに在籍する日本人スタッフが面談を実施することも可能。言語の壁なく、現地の状況をリアルタイムで保護者にお伝えします。",
                color: "bg-amber-100 text-amber-600",
                badge: "現地日本人在籍",
              },
            ].map((card, i) => (
              <div key={i} className="bg-gray-50 rounded-xl p-6 border border-gray-100 hover:border-emerald-200 transition-all relative">
                <div className="absolute -top-3 left-5">
                  <span className="bg-emerald-600 text-white text-xs font-bold px-3 py-1 rounded-full">{card.badge}</span>
                </div>
                <div className={`w-11 h-11 flex items-center justify-center rounded-full ${card.color} mb-4 mt-2`}>
                  <i className={`${card.icon} text-xl`} />
                </div>
                <h3 className="font-bold text-gray-800 mb-2 text-sm">{card.title}</h3>
                <p className="text-sm text-gray-600 leading-relaxed">{card.body}</p>
              </div>
            ))}
          </div>

          {/* ── 視察ツアー バナー ── */}
          <div className="relative rounded-2xl overflow-hidden mb-12">
            <img
              src="https://readdy.ai/api/search-image?query=Japanese%20family%20parents%20and%20teenage%20child%20visiting%20Irish%20school%20campus%20green%20lawn%20historic%20building%20sunny%20day%20cheerful%20tour%20guide%20friendly%20atmosphere%20Dublin%20Ireland&width=1200&height=400&seq=tour-banner-001&orientation=landscape"
              alt="親子現地視察ツアー"
              className="w-full h-56 object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-black/20" />
            <div className="absolute inset-0 flex items-center px-8 md:px-12">
              <div className="max-w-xl">
                <div className="inline-flex items-center gap-2 bg-emerald-500 text-white text-xs font-bold px-3 py-1.5 rounded-full mb-4">
                  <i className="ri-plane-line" />
                  <span>ClassLive留学 オプションサービス</span>
                </div>
                <h3 className="text-xl md:text-2xl font-bold text-white mb-2" style={{ fontFamily: "'Noto Serif JP', serif" }}>
                  親子での現地視察ツアーも手配可能！
                </h3>
                <p className="text-white/85 text-sm leading-relaxed mb-5">
                  「実際の学校や滞在先を見てから決めたい」というご家族のために、現地視察ツアーのアレンジも承ります。
                  日本人スタッフがサポートするため、英語に不安がある親御様も安心してご参加いただけます。
                </p>
                <a
                  href="#hs-contact"
                  onClick={(e) => { e.preventDefault(); document.getElementById("hs-contact")?.scrollIntoView({ behavior: "smooth" }); }}
                  className="inline-flex items-center gap-2 bg-white text-emerald-700 font-bold text-sm px-6 py-2.5 rounded-full hover:bg-emerald-50 transition-colors cursor-pointer whitespace-nowrap"
                >
                  <span className="w-4 h-4 flex items-center justify-center"><i className="ri-mail-send-line" /></span>
                  詳細をお問い合わせ
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── WHY IRELAND ── */}
      <section className="py-20 bg-white">
        <div className="max-w-6xl mx-auto px-6">
          <div className="text-center mb-14">
            <span className="text-emerald-600 text-sm font-semibold tracking-widest uppercase">Why Ireland</span>
            <h2 className="text-3xl font-bold text-gray-800 mt-2" style={{ fontFamily: "'Noto Serif JP', serif" }}>
              なぜアイルランドで高校留学なのか
            </h2>
            <p className="text-gray-500 text-sm mt-3 max-w-xl mx-auto">他の英語圏と比較しながら、アイルランドならではの強みをご説明します。</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-14">
            {[
              {
                icon: "ri-user-unfollow-line",
                title: "日本人が圧倒的に少ない",
                body: "NZやカナダと違い、アイルランドはまだ穴場。「クラスに日本人は自分だけ」という完全な英語漬け環境が整っています。本気で英語を伸ばしたい人に最適です。",
                color: "bg-emerald-100 text-emerald-600",
              },
              {
                icon: "ri-shield-star-line",
                title: "世界トップクラスの安全性",
                body: "世界平和度指数（GPI）で常に上位にランクイン（世界2位）。日本（16位程度）より安全で、犯罪・自然災害が非常に少なく、未成年の一人留学でも安心です。",
                color: "bg-amber-100 text-amber-600",
              },
              {
                icon: "ri-money-euro-circle-line",
                title: "費用がリーズナブル",
                body: "円安の影響が大きい米国や物価急騰のオーストラリアと比べ、総額を抑えやすい。私立でも年間€22,000台〜と、他国の私立留学と比較しても非常にリーズナブルです。",
                color: "bg-sky-100 text-sky-600",
              },
              {
                icon: "ri-award-line",
                title: "国際的に認知された卒業資格",
                body: "Leaving Certificate（統一卒業試験）はIBやAレベルと同様に国際的に認知。イギリス・アメリカ・ヨーロッパの大学進学に通用する強力な資格です。",
                color: "bg-rose-100 text-rose-600",
              },
              {
                icon: "ri-building-4-line",
                title: "IT・経済大国ダブリン",
                body: "Google・Apple・Meta・Amazonの欧州本社がダブリンに集結。一人当たりGDP世界3位の経済力を誇るEUの中心地で学ぶことで、将来のキャリアにも刺激を与えます。",
                color: "bg-purple-100 text-purple-600",
              },
              {
                icon: "ri-heart-3-line",
                title: "ケルト文化と温かな人柄",
                body: "移民国家とは異なりアイリッシュ（現地住民）比率が高く、ケルト文化や伝統的なおもてなしの精神が残ります。親日家が多く、初めての留学でも馴染みやすい国です。",
                color: "bg-teal-100 text-teal-600",
              },
            ].map((card, i) => (
              <div key={i} className="bg-gray-50 rounded-lg p-6 border border-gray-100 hover:border-emerald-200 transition-all">
                <div className={`w-10 h-10 flex items-center justify-center rounded-full ${card.color} mb-4`}>
                  <i className={`${card.icon} text-lg`} />
                </div>
                <h3 className="font-bold text-gray-800 mb-2 text-sm">{card.title}</h3>
                <p className="text-sm text-gray-600 leading-relaxed">{card.body}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── SCHOOL SYSTEM + TY ── */}
      <section className="py-20" style={{ background: "linear-gradient(135deg, #f0fdf4 0%, #ecfdf5 100%)" }}>
        <div className="max-w-5xl mx-auto px-6">
          <div className="text-center mb-12">
            <span className="text-emerald-600 text-sm font-semibold tracking-widest uppercase">School System</span>
            <h2 className="text-3xl font-bold text-gray-800 mt-2" style={{ fontFamily: "'Noto Serif JP', serif" }}>
              アイルランドの学校制度
            </h2>
            <p className="text-gray-500 text-sm mt-3">日本にはない独自の制度が、留学生にとって大きなチャンスになります。</p>
          </div>

          {/* System diagram */}
          <div className="flex flex-col md:flex-row items-center justify-center gap-3 mb-12">
            {[
              { title: "ジュニアサイクル", sub: "1〜3年生 / 12〜15歳", desc: "基礎学習", color: "bg-sky-100 border-sky-300 text-sky-800" },
              { title: "▶", sub: "", desc: "", color: "text-gray-400 text-2xl", arrow: true },
              { title: "TY（トランジションイヤー）", sub: "4年生 / 15〜16歳", desc: "社会体験の1年間", color: "bg-emerald-100 border-emerald-400 text-emerald-800", star: true },
              { title: "▶", sub: "", desc: "", color: "text-gray-400 text-2xl", arrow: true },
              { title: "シニアサイクル", sub: "5〜6年生 / 16〜18歳", desc: "大学受験準備", color: "bg-amber-100 border-amber-300 text-amber-800" },
            ].map((s, i) =>
              s.arrow ? (
                <div key={i} className="text-gray-300 text-3xl hidden md:block">▶</div>
              ) : (
                <div key={i} className={`flex-1 rounded-lg border-2 p-5 text-center ${s.color} relative`}>
                  {s.star && (
                    <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-emerald-600 text-white text-xs font-bold px-3 py-0.5 rounded-full whitespace-nowrap">
                      ⭐ 留学生最大の切り札
                    </div>
                  )}
                  <div className="font-bold text-sm mt-2">{s.title}</div>
                  <div className="text-xs mt-1 opacity-70">{s.sub}</div>
                  <div className="text-xs mt-1.5 font-semibold">{s.desc}</div>
                </div>
              )
            )}
          </div>

          {/* TY Feature */}
          <div className="bg-white rounded-xl border-2 border-emerald-300 overflow-hidden">
            <div className="bg-emerald-600 px-6 py-4">
              <div className="flex items-center gap-3">
                <div className="w-8 h-8 flex items-center justify-center bg-white/20 rounded-full text-white">
                  <i className="ri-star-smile-line" />
                </div>
                <div>
                  <h3 className="font-bold text-white">TY（トランジションイヤー）── 留学生最大の切り札</h3>
                  <p className="text-emerald-200 text-xs mt-0.5">アイルランド独自の「学業をお休みして社会体験をする1年間」</p>
                </div>
              </div>
            </div>
            <div className="p-6">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <h4 className="font-bold text-gray-800 text-sm mb-3 flex items-center gap-2">
                    <span className="w-5 h-5 flex items-center justify-center text-emerald-600"><i className="ri-checkbox-circle-line" /></span>
                    TYがすごい理由
                  </h4>
                  <ul className="space-y-2.5">
                    {[
                      { icon: "ri-book-close-line", text: "試験勉強なし！社会体験・職場体験・ボランティアが中心" },
                      { icon: "ri-english-input", text: "英語に自信がなくても参加可能。現地の生活の中で自然に英語力が身についていきます" },
                      { icon: "ri-team-line", text: "学校生活に慣れながら友達ができる。英語耳・英語力が自然に育つ" },
                      { icon: "ri-briefcase-4-line", text: "職場体験（WorkExperience）でリアルな英語環境を体験" },
                    ].map((item, i) => (
                      <li key={i} className="flex items-start gap-2 text-sm text-gray-700">
                        <span className="w-4 h-4 flex items-center justify-center text-emerald-500 flex-shrink-0 mt-0.5"><i className={item.icon} /></span>
                        {item.text}
                      </li>
                    ))}
                  </ul>
                </div>
                <div>
                  <h4 className="font-bold text-gray-800 text-sm mb-3 flex items-center gap-2">
                    <span className="w-5 h-5 flex items-center justify-center text-emerald-600"><i className="ri-calendar-todo-line" /></span>
                    TYで経験できること
                  </h4>
                  <div className="flex flex-wrap gap-2">
                    {["職場体験（カフェ・事務所など）", "ボランティア活動", "演劇・料理・音楽", "起業体験プログラム", "救急法・ファーストエイド", "地域コミュニティ活動", "スポーツ強化週間", "アウトドア体験"].map((tag) => (
                      <span key={tag} className="bg-emerald-50 text-emerald-700 text-xs px-2.5 py-1 rounded-full border border-emerald-100">{tag}</span>
                    ))}
                  </div>
                  <div className="mt-4 bg-emerald-50 rounded-lg px-4 py-3 border border-emerald-100">
                    <p className="text-xs text-emerald-800 leading-relaxed">
                      <strong>カウンセラーより：</strong>「いきなり現地の授業についていけるか不安」という生徒にとって、TYは英語力・学校生活・人間関係の基盤を作る最高の1年間です。TYから始めてシニアサイクルへ進む生徒が多くいます。
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── CURRICULUM ── */}
      <section className="py-20 bg-white">
        <div className="max-w-5xl mx-auto px-6">
          <div className="text-center mb-12">
            <span className="text-emerald-600 text-sm font-semibold tracking-widest uppercase">Curriculum</span>
            <h2 className="text-3xl font-bold text-gray-800 mt-2" style={{ fontFamily: "'Noto Serif JP', serif" }}>
              シニアサイクルの授業科目例
            </h2>
            <p className="text-gray-500 text-sm mt-3 max-w-xl mx-auto">
              Leaving Certificateに向けた2年間。必修3科目に加え、自分の得意・興味に合わせて選択科目を組み合わせます。
            </p>
          </div>

          {/* Subject table */}
          <div className="overflow-x-auto mb-8">
            <table className="w-full border-collapse text-sm">
              <thead>
                <tr>
                  <th className="bg-rose-100 text-rose-800 border border-rose-200 px-4 py-3 text-center font-bold w-32" rowSpan={2}>
                    履修義務科目
                  </th>
                  <th className="bg-emerald-600 text-white border border-emerald-700 px-4 py-3 text-center font-bold" colSpan={5}>
                    履修選択科目
                  </th>
                </tr>
                <tr>
                  {["現代外国語", "実験科学", "応用科学", "芸術および人文学", "ビジネス学"].map((cat) => (
                    <th key={cat} className="bg-emerald-50 text-emerald-800 border border-emerald-200 px-3 py-2.5 text-center font-bold text-xs">
                      {cat}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {[
                  {
                    required: "英語",
                    foreign: "スペイン語",
                    science: "物理学",
                    applied: "テクノロジー",
                    arts: "歴史",
                    business: "会計学",
                  },
                  {
                    required: "数学",
                    foreign: "フランス語",
                    science: "化学",
                    applied: "機械工学",
                    arts: "古典学",
                    business: "ビジネス学",
                  },
                  {
                    required: "アイルランド語 *",
                    foreign: "イタリア語",
                    science: "biology",
                    applied: "家政学",
                    arts: "音楽",
                    business: "経済学",
                  },
                  {
                    required: "",
                    foreign: "ドイツ語",
                    science: "農学",
                    applied: "デザイン・コミュニケーションシグナル",
                    arts: "芸術",
                    business: "",
                  },
                  {
                    required: "",
                    foreign: "ロシア語",
                    science: "応用数学",
                    applied: "建築学",
                    arts: "地理",
                    business: "",
                  },
                  {
                    required: "",
                    foreign: "日本語",
                    science: "",
                    applied: "",
                    arts: "宗教教育",
                    business: "",
                  },
                ].map((row, i) => (
                  <tr key={i} className={i % 2 === 0 ? "bg-white" : "bg-gray-50/50"}>
                    <td className="border border-rose-100 px-4 py-2.5 text-center text-rose-700 font-semibold text-xs bg-rose-50/60">
                      {row.required}
                    </td>
                    <td className="border border-gray-100 px-3 py-2.5 text-center text-gray-700 text-xs">{row.foreign}</td>
                    <td className="border border-gray-100 px-3 py-2.5 text-center text-gray-700 text-xs">{row.science}</td>
                    <td className="border border-gray-100 px-3 py-2.5 text-center text-gray-700 text-xs">{row.applied}</td>
                    <td className="border border-gray-100 px-3 py-2.5 text-center text-gray-700 text-xs">{row.arts}</td>
                    <td className="border border-gray-100 px-3 py-2.5 text-center text-gray-700 text-xs">{row.business}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Notes */}
          <div className="bg-gray-50 rounded-xl border border-gray-100 p-6 mb-8">
            <h4 className="font-bold text-gray-700 text-xs mb-3 flex items-center gap-2">
              <span className="w-4 h-4 flex items-center justify-center text-emerald-600"><i className="ri-information-line" /></span>
              注意事項・ポイント
            </h4>
            <ul className="space-y-2">
              {[
                { text: "* 留学生は、アイルランド語（ゲール語）の授業の免除が認められています", highlight: true },
                { text: "一般的に、Leaving Certificate（卒業試験）には6科目以上の履修が必須です", highlight: false },
                { text: "学校によっては、このリストに掲載されていない科目も履修可能な場合があります", highlight: false },
                { text: "提携校の中には「パーソナル・ファイナンス」「中国語・中国文化」「ウェブ・デザイン」などの独自の短期コースを提供する学校もあります", highlight: false },
              ].map((note, i) => (
                <li key={i} className={`flex items-start gap-2 text-xs leading-relaxed ${note.highlight ? "text-emerald-700 font-semibold" : "text-gray-600"}`}>
                  <span className={`w-4 h-4 flex items-center justify-center flex-shrink-0 mt-0.5 ${note.highlight ? "text-emerald-500" : "text-emerald-400"}`}>
                    <i className="ri-checkbox-blank-circle-fill text-[6px]" />
                  </span>
                  {note.text}
                </li>
              ))}
            </ul>
          </div>

          {/* Subject selection tips */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
            {[
              {
                icon: "ri-translate-2",
                title: "語学系を重視したい",
                desc: "英語 ＋ スペイン語・フランス語などを組み合わせ。将来の国際ビジネス・通訳・外交キャリアに強い組み合わせです。",
                color: "bg-sky-50 border-sky-200 text-sky-700",
                iconColor: "bg-sky-100 text-sky-600",
              },
              {
                icon: "ri-flask-line",
                title: "理系・大学進学を目指す",
                desc: "数学 ＋ 物理・化学・生物を選択。欧米の理系学部進学に対応したカリキュラムで、Leaving Certの高得点を狙えます。",
                color: "bg-emerald-50 border-emerald-200 text-emerald-700",
                iconColor: "bg-emerald-100 text-emerald-600",
              },
              {
                icon: "ri-bar-chart-box-line",
                title: "ビジネス・経済を学びたい",
                desc: "会計学・ビジネス学・経済学を組み合わせ。ダブリンのIT・金融企業が集まる環境でビジネス感覚を磨けます。",
                color: "bg-amber-50 border-amber-200 text-amber-700",
                iconColor: "bg-amber-100 text-amber-600",
              },
            ].map((tip, i) => (
              <div key={i} className={`rounded-xl border p-5 ${tip.color}`}>
                <div className={`w-9 h-9 flex items-center justify-center rounded-full ${tip.iconColor} mb-3`}>
                  <i className={`${tip.icon} text-base`} />
                </div>
                <h4 className="font-bold text-sm mb-2">{tip.title}</h4>
                <p className="text-xs leading-relaxed opacity-85">{tip.desc}</p>
              </div>
            ))}
          </div>

          <div className="mt-6 bg-emerald-50 border border-emerald-200 rounded-lg px-5 py-4 flex items-start gap-3">
            <div className="w-8 h-8 flex items-center justify-center rounded-full bg-emerald-100 text-emerald-600 flex-shrink-0">
              <i className="ri-lightbulb-line text-sm" />
            </div>
            <p className="text-xs text-emerald-800 leading-relaxed">
              <strong>科目選択のサポートについて：</strong>
              どの科目を選ぶべきかのアドバイスも可能です。将来の進路・大学・得意科目を踏まえた最適な組み合わせをご提案しますのでご安心ください！
            </p>
          </div>
        </div>
      </section>

      {/* ── PROGRAM OVERVIEW ── */}
      <section className="py-20" style={{ background: "linear-gradient(135deg, #f0fdf4 0%, #ecfdf5 100%)" }}>
        <div className="max-w-5xl mx-auto px-6">
          <div className="text-center mb-12">
            <span className="text-emerald-600 text-sm font-semibold tracking-widest uppercase">Program</span>
            <h2 className="text-3xl font-bold text-gray-800 mt-2" style={{ fontFamily: "'Noto Serif JP', serif" }}>
              高校留学プログラム概要
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="bg-gray-50 rounded-lg p-7 border border-gray-100">
              <h3 className="font-bold text-gray-800 mb-5 flex items-center gap-2 text-sm">
                <span className="w-6 h-6 flex items-center justify-center text-emerald-600"><i className="ri-information-line" /></span>
                基本情報
              </h3>
              <div className="space-y-4">
                {[
                  { label: "対象年齢", value: "15〜18歳（高校1年生〜高校3年生）" },
                  { label: "留学期間", value: "1学期（約4ヶ月）〜最大3学年" },
                  { label: "入学時期", value: "9月（新学年スタート）" },
                  { label: "授業形式", value: "現地生徒と同じクラスに参加" },
                  { label: "滞在形式", value: "ホームステイ（デイスクール）/ 寄宿（ボーディング）" },
                  { label: "学費目安", value: "年間 €22,150〜€42,645（学校・プログラムによる）" },
                  { label: "費用内訳", value: "学費・滞在費・ガーディアン費・空港送迎が含まれます" },
                ].map((row, i) => (
                  <div key={i} className="flex items-start gap-3 border-b border-gray-100 pb-3 last:border-0">
                    <span className="text-xs font-semibold text-emerald-600 w-24 flex-shrink-0 mt-0.5">{row.label}</span>
                    <span className="text-sm text-gray-700">{row.value}</span>
                  </div>
                ))}
              </div>
            </div>

            <div className="space-y-5">
              <div className="bg-gray-50 rounded-lg p-6 border border-gray-100">
                <h3 className="font-bold text-gray-800 mb-4 flex items-center gap-2 text-sm">
                  <span className="w-5 h-5 flex items-center justify-center text-emerald-600"><i className="ri-calendar-event-line" /></span>
                  学期スケジュール
                </h3>
                {[
                  { term: "第1学期", period: "9月〜12月", note: "12月末クリスマス休暇（一時帰国推奨）" },
                  { term: "第2学期", period: "1月〜4月", note: "4月イースター休暇あり" },
                  { term: "第3学期", period: "4月〜6月", note: "6月以降は夏休み（一時帰国）" },
                ].map((s, i) => (
                  <div key={i} className="flex items-start gap-3 mb-3 last:mb-0">
                    <span className="bg-emerald-600 text-white text-xs font-bold px-2 py-0.5 rounded whitespace-nowrap">{s.term}</span>
                    <div>
                      <div className="text-sm font-semibold text-gray-800">{s.period}</div>
                      <div className="text-xs text-gray-500">{s.note}</div>
                    </div>
                  </div>
                ))}
              </div>

              <div className="bg-gray-50 rounded-lg p-6 border border-gray-100">
                <h3 className="font-bold text-gray-800 mb-4 flex items-center gap-2 text-sm">
                  <span className="w-5 h-5 flex items-center justify-center text-emerald-600"><i className="ri-time-line" /></span>
                  典型的な一日の流れ
                </h3>
                {[
                  { time: "08:30", act: "登校・朝のHR（ホームルーム）" },
                  { time: "09:00", act: "午前の授業（各45分 × 4コマ）" },
                  { time: "13:00", act: "ランチブレイク（学食またはパックランチ）" },
                  { time: "14:00", act: "午後の授業（4コマ）" },
                  { time: "16:30", act: "放課後・地域クラブ活動" },
                  { time: "19:00", act: "ホームステイ家族と夕食" },
                ].map((s, i) => (
                  <div key={i} className="flex items-center gap-3 text-xs text-gray-600 mb-2 last:mb-0">
                    <span className="w-12 flex-shrink-0 text-emerald-600 font-semibold">{s.time}</span>
                    <span>{s.act}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── SCHOOLS ── */}
      <section id="hs-schools" className="py-20" style={{ background: "linear-gradient(135deg, #f0fdf4 0%, #ecfdf5 100%)" }}>
        <div className="max-w-6xl mx-auto px-6">
          <div className="text-center mb-12">
            <span className="text-emerald-600 text-sm font-semibold tracking-widest uppercase">Partner Schools</span>
            <h2 className="text-3xl font-bold text-gray-800 mt-2" style={{ fontFamily: "'Noto Serif JP', serif" }}>
              提携高校のご紹介
            </h2>
            <p className="text-gray-500 text-sm mt-3">目的・スタイルに合わせて、最適な学校をご提案します。15校以上の提携校があります。</p>
          </div>

          {/* Tab switcher */}
          <div className="flex justify-center mb-6">
            <div className="bg-white rounded-full p-1 border border-gray-200 flex gap-1">
              <button
                onClick={() => setSchoolTab("day")}
                className={`px-4 py-2 md:px-6 md:py-2.5 rounded-full text-xs md:text-sm font-semibold transition-all cursor-pointer whitespace-nowrap ${schoolTab === "day" ? "bg-emerald-600 text-white" : "text-gray-600 hover:text-emerald-600"}`}
              >
                デイスクール（通学）3校
              </button>
              <button
                onClick={() => setSchoolTab("boarding")}
                className={`px-4 py-2 md:px-6 md:py-2.5 rounded-full text-xs md:text-sm font-semibold transition-all cursor-pointer whitespace-nowrap ${schoolTab === "boarding" ? "bg-emerald-600 text-white" : "text-gray-600 hover:text-emerald-600"}`}
              >
                ボーディングスクール（寮制）3校
              </button>
            </div>
          </div>

          {/* Tab description */}
          <div className="max-w-2xl mx-auto mb-8 text-center">
            {schoolTab === "day" ? (
              <p className="text-sm text-gray-600 leading-relaxed bg-white border border-emerald-100 rounded-xl px-6 py-4">
                <span className="w-4 h-4 inline-flex items-center justify-center text-emerald-500 mr-1"><i className="ri-home-heart-line" /></span>
                現地の家庭での生活（ホームステイ）を通じて、アイルランドの文化に深く浸りながら、個性豊かな教育を受けられる学校です。
              </p>
            ) : (
              <p className="text-sm text-gray-600 leading-relaxed bg-white border border-emerald-100 rounded-xl px-6 py-4">
                <span className="w-4 h-4 inline-flex items-center justify-center text-emerald-500 mr-1"><i className="ri-community-line" /></span>
                24時間の生活管理体制が整っており、多感な時期に自立心と国際的なネットワークを育むのに最適な環境です。
              </p>
            )}
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
            {(schoolTab === "day" ? daySchools : boardingSchools).map((s, i) => (
              <div key={i} className={`bg-white rounded-lg overflow-hidden border transition-all hover:border-emerald-300 ${s.highlight ? "border-emerald-300 ring-1 ring-emerald-200" : "border-gray-100"}`}>
                {/* School Image */}
                <div className="w-full h-48 relative overflow-hidden">
                  <img
                    src={s.img}
                    alt={s.name}
                    className="w-full h-full object-cover"
                    style={{ objectPosition: s.objectPosition || "center top" }}
                  />
                  {s.highlight && (
                    <div className="absolute top-2 left-2 text-xs font-bold text-emerald-600 bg-white border border-emerald-200 px-2.5 py-1 rounded-full">⭐ おすすめ</div>
                  )}
                  <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/50 to-transparent h-16" />
                  <div className="absolute bottom-2 right-2 text-xs font-bold text-white bg-emerald-600/90 px-2.5 py-1 rounded">{s.fee}</div>
                </div>
                {/* Card Content */}
                <div className="p-5">
                  <div className="mb-2">
                    <h3 className="font-bold text-gray-800 text-sm leading-snug">{s.name}</h3>
                    {s.nameNote && <span className="text-xs text-amber-600 font-medium">{s.nameNote}</span>}
                  </div>
                  <div className="flex items-center gap-3 text-xs text-gray-500 mb-3">
                    <span className="flex items-center gap-1">
                      <span className="w-3.5 h-3.5 flex items-center justify-center"><i className="ri-map-pin-line" /></span>
                      {s.location}
                    </span>
                    <span className="bg-gray-100 text-gray-500 px-2 py-0.5 rounded">{s.type}</span>
                  </div>
                  {/* 特徴 */}
                  <div className="mb-2">
                    <span className="text-xs font-bold text-emerald-700 mr-1">特徴</span>
                    <span className="text-xs text-gray-600">{s.tokuchou}</span>
                  </div>
                  {/* 教育 */}
                  <div className="mb-3">
                    <span className="text-xs font-bold text-emerald-700 mr-1">教育</span>
                    <span className="text-xs text-gray-600 leading-relaxed">{s.kyouiku}</span>
                  </div>
                  <div className="flex flex-wrap gap-1.5 mb-2.5">
                    {s.features.map((f, j) => (
                      <span key={j} className="bg-emerald-50 text-emerald-700 text-xs px-2 py-0.5 rounded-full border border-emerald-100">{f}</span>
                    ))}
                  </div>
                  <p className="text-xs text-gray-400 border-t border-gray-50 pt-2.5 italic">{s.note}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-8 text-center">
            <p className="text-xs text-gray-500">※費用は2026-2027年度参考価格（学費＋滞在費＋ガーディアン費＋空港送迎を含むパッケージ）。詳細は無料相談にてご案内します。</p>
          </div>
        </div>
      </section>

      {/* ── ATLAS GUARDIAN → 2つのサポート体制 ── */}
      <section className="py-20 bg-white">
        <div className="max-w-5xl mx-auto px-6">
          <div className="text-center mb-12">
            <span className="text-emerald-600 text-sm font-semibold tracking-widest uppercase">Support System</span>
            <h2 className="text-3xl font-bold text-gray-800 mt-2" style={{ fontFamily: "'Noto Serif JP', serif" }}>
              安心を支える2つのサポート体制
            </h2>
            <p className="text-gray-500 text-sm mt-3 max-w-xl mx-auto">
              現地のガーディアンスタッフ（英語サポート）と、ClassLive留学（日本語サポート）が連携し、お子様と保護者の両方をしっかり支えます。
            </p>
          </div>

          {/* Two support columns */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-10">
            {/* Local Support Side */}
            <div className="rounded-xl border-2 border-gray-200 overflow-hidden">
              <div className="bg-gray-700 px-6 py-4 flex items-center gap-3">
                <div className="w-9 h-9 flex items-center justify-center rounded-full bg-white/15 text-white flex-shrink-0">
                  <i className="ri-shield-user-line text-lg" />
                </div>
                <div>
                  <div className="font-bold text-white text-sm">現地サポート（ガーディアンシップ）</div>
                  <div className="text-white/60 text-xs mt-0.5">アイルランド現地スタッフによるサポート体制</div>
                </div>
              </div>
              <div className="p-6 space-y-3">
                {[
                  { icon: "ri-plane-line", title: "空港送迎・到着サポート", desc: "到着日に現地スタッフが空港でお出迎え。ホームステイ先まで安全に送り届け。" },
                  { icon: "ri-calendar-check-line", title: "定期1対1面談", desc: "最初の4週間は毎週、以降は毎月1対1面談。悩みや問題を早期発見します。" },
                  { icon: "ri-discuss-line", title: "学校・ホスト家庭との調整", desc: "三者面談の代理出席、科目選択のアドバイス、トラブル仲裁。" },
                  { icon: "ri-file-text-line", title: "毎月のウェルフェアレポート", desc: "生活状況・心身の健康・学校生活を毎月レポートで保護者へ報告。" },
                  { icon: "ri-government-line", title: "ビザ・法的手続きサポート", desc: "外国人登録（IRP）への同行サポート、ビザ更新手続きをフルサポート。" },
                  { icon: "ri-alarm-warning-line", title: "24時間緊急対応", desc: "緊急時は24時間対応可能な連絡体制を完備。万が一の際も安心です。" },
                ].map((item, i) => (
                  <div key={i} className="flex items-start gap-3">
                    <div className="w-7 h-7 flex items-center justify-center rounded-full bg-gray-100 text-gray-600 flex-shrink-0">
                      <i className={`${item.icon} text-xs`} />
                    </div>
                    <div>
                      <div className="text-sm font-semibold text-gray-800">{item.title}</div>
                      <div className="text-xs text-gray-500 mt-0.5 leading-relaxed">{item.desc}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* ClassLive Side */}
            <div className="rounded-xl border-2 border-emerald-300 overflow-hidden">
              <div className="bg-emerald-600 px-6 py-4 flex items-center gap-3">
                <div className="w-9 h-9 flex items-center justify-center rounded-full bg-white/20 text-white flex-shrink-0">
                  <i className="ri-customer-service-2-line text-lg" />
                </div>
                <div>
                  <div className="font-bold text-white text-sm">ClassLive留学限定サポート</div>
                  <div className="text-emerald-200 text-xs mt-0.5">ClassLive留学（日本窓口／現地日本人スタッフ）</div>
                </div>
              </div>
              <div className="p-6 space-y-3">
                {[
                  { icon: "ri-chat-smile-2-line", title: "出発前の準備から帰国まで一貫サポート", desc: "学校選び・書類作成・保険手配・出発前オリエンテーションまで、すべて日本語でサポートします。", highlight: true },
                  { icon: "ri-line-fill", title: "LINEによる日本語での気軽な相談", desc: "些細な疑問・不安もLINEで即日対応。保護者・生徒どちらもいつでも連絡OK。", highlight: true },
                  { icon: "ri-translate-2", title: "英語書類の翻訳・代行サポート", desc: "学校からの英語の書類・レポートを日本語でわかりやすくご説明します。" },
                  { icon: "ri-parent-line", title: "保護者向け日本語レポート", desc: "毎月のウェルフェアレポートを日本語で補足説明。保護者の不安を解消します。" },
                  { icon: "ri-money-cny-circle-line", title: "カウンセリング・サポートはすべて無料", desc: "ご相談から手続きサポートまで保護者・生徒様のご負担は一切ありません。" },
                ].map((item, i) => (
                  <div key={i} className={`flex items-start gap-3 ${item.highlight ? "bg-emerald-50 rounded-lg p-2.5 -mx-1" : ""}`}>
                    <div className="w-7 h-7 flex items-center justify-center rounded-full bg-emerald-100 text-emerald-600 flex-shrink-0">
                      <i className={`${item.icon} text-xs`} />
                    </div>
                    <div>
                      <div className={`text-sm font-semibold ${item.highlight ? "text-emerald-800" : "text-gray-800"}`}>{item.title}</div>
                      <div className="text-xs text-gray-500 mt-0.5 leading-relaxed">{item.desc}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Combined summary */}
          <div className="bg-gray-50 rounded-xl border border-gray-100 p-6">
            <div className="flex items-start gap-4">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-emerald-100 text-emerald-600 flex-shrink-0">
                <i className="ri-links-line text-lg" />
              </div>
              <div>
                <h4 className="font-bold text-gray-800 text-sm mb-2">現地サポート × ClassLive留学 — 連携サポート体制</h4>
                <p className="text-sm text-gray-600 leading-relaxed">
                  現地の英語サポートスタッフと、日本のClassLive留学スタッフが常に連絡を取り合い、情報を共有します。
                  「現地の状況は英語で把握できても、保護者への報告は日本語で」という課題をClassLive留学が解決します。
                  <strong className="text-emerald-700"> お子様は英語環境で成長し、保護者は日本語で安心して見守れる</strong> ——それがこのプログラムの最大の強みです。
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── COST ── */}
      <section className="py-20" style={{ background: "linear-gradient(135deg, #f0fdf4 0%, #ecfdf5 100%)" }}>
        <div className="max-w-5xl mx-auto px-6">
          <div className="text-center mb-12">
            <span className="text-emerald-600 text-sm font-semibold tracking-widest uppercase">Cost</span>
            <h2 className="text-3xl font-bold text-gray-800 mt-2" style={{ fontFamily: "'Noto Serif JP', serif" }}>
              費用の内訳について
            </h2>
            <p className="text-gray-500 text-sm mt-3">表示価格は「授業料＋滞在費＋ガーディアン費＋送迎」がすべて込みのパッケージ価格です。</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
            <div className="bg-white rounded-xl border border-emerald-200 overflow-hidden">
              <div className="bg-emerald-600 px-5 py-3 flex items-center gap-2">
                <div className="w-5 h-5 flex items-center justify-center text-white"><i className="ri-checkbox-circle-fill" /></div>
                <h3 className="font-bold text-white text-sm">パッケージ料金に含まれるもの</h3>
              </div>
              <div className="p-5 space-y-2.5">
                {[
                  "学校の授業料",
                  "滞在費（フルボード：朝・昼・夕食込み）",
                  "中間休暇・イースター休暇中の滞在費も含む",
                  "教育ガーディアン費用（全サポート）",
                  "到着時・帰国時の空港送迎",
                ].map((item, i) => (
                  <div key={i} className="flex items-start gap-2 text-sm text-gray-700">
                    <span className="w-4 h-4 flex items-center justify-center text-emerald-500 flex-shrink-0 mt-0.5"><i className="ri-check-line" /></span>
                    {item}
                  </div>
                ))}
              </div>
            </div>

            <div className="bg-white rounded-xl border border-amber-200 overflow-hidden">
              <div className="bg-amber-500 px-5 py-3 flex items-center gap-2">
                <div className="w-5 h-5 flex items-center justify-center text-white"><i className="ri-information-fill" /></div>
                <h3 className="font-bold text-white text-sm">別途必要な費用（目安）</h3>
              </div>
              <div className="p-5 space-y-2.5">
                {[
                  { item: "航空券", note: "往復 約15〜20万円前後" },
                  { item: "海外医療・旅行保険（必須）", note: "年間 €400程度（プログラム経由）" },
                  { item: "クリスマス休暇中の滞在費", note: "原則一時帰国（滞在時は追加費用）" },
                  { item: "制服・教科書代", note: "諸経費預かり金（€1,500/年）から支払い" },
                  { item: "TY特別活動費", note: "€500〜€900程度" },
                  { item: "学校デポジット（申込時）", note: "€1,750〜€5,000（学校ごとに異なる）" },
                ].map((item, i) => (
                  <div key={i} className="flex items-start gap-2 text-sm text-gray-700">
                    <span className="w-4 h-4 flex items-center justify-center text-amber-500 flex-shrink-0 mt-0.5"><i className="ri-arrow-right-s-line" /></span>
                    <div>
                      {item.item}
                      <span className="text-xs text-gray-400 ml-1">（{item.note}）</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="bg-white rounded-lg border border-gray-100 p-5">
            <h4 className="font-bold text-gray-800 text-sm mb-4 flex items-center gap-2">
              <span className="w-5 h-5 flex items-center justify-center text-emerald-600"><i className="ri-calendar-2-line" /></span>
              支払いスケジュール
            </h4>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              {[
                { phase: "申込確定時", amount: "デポジット 30%", note: "席確保のため必須" },
                { phase: "到着の6週間前", amount: "残金 70%", note: "出発前に完了" },
                { phase: "複数年の場合", amount: "1年ごとに支払い", note: "3年留学でも年単位" },
              ].map((p, i) => (
                <div key={i} className="bg-gray-50 rounded-lg p-4 border border-gray-100 text-center">
                  <div className="text-xs text-gray-500 mb-1">{p.phase}</div>
                  <div className="font-bold text-emerald-700 text-sm">{p.amount}</div>
                  <div className="text-xs text-gray-400 mt-1">{p.note}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* ── TIMELINE ── */}
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-6">
          <div className="text-center mb-12">
            <span className="text-emerald-600 text-sm font-semibold tracking-widest uppercase">Flow</span>
            <h2 className="text-3xl font-bold text-gray-800 mt-2" style={{ fontFamily: "'Noto Serif JP', serif" }}>
              留学開始までの10ステップ
            </h2>
            <p className="text-gray-500 text-sm mt-3">初回相談から留学スタートまで、ClassLive留学がすべてをサポートします。</p>
          </div>

          <div className="relative">
            <div className="absolute left-8 top-0 bottom-0 w-0.5 bg-emerald-200 hidden md:block" />
            <div className="space-y-4">
              {timeline.map((t, i) => (
                <div key={i} className="flex items-start gap-5">
                  <div className="relative flex-shrink-0">
                    <div className={`w-16 h-16 flex flex-col items-center justify-center rounded-full text-white z-10 relative ${i === 9 ? "bg-emerald-700" : "bg-emerald-600"}`}>
                      <div className="w-5 h-5 flex items-center justify-center"><i className={`${t.icon} text-base`} /></div>
                      <span className="text-xs font-bold mt-0.5">{t.step}</span>
                    </div>
                  </div>
                  <div className={`rounded-lg p-5 flex-1 border mt-2 ${i === 9 ? "bg-emerald-50 border-emerald-200" : "bg-gray-50 border-gray-100"}`}>
                    <h3 className="font-bold text-gray-800 mb-1 text-sm">{t.title}</h3>
                    <p className="text-sm text-gray-600">{t.desc}</p>
                    {/* Extra info boxes at specific steps */}
                    {i === 3 && (
                      <div className="mt-3 bg-sky-50 border border-sky-100 rounded-lg p-3 text-xs text-sky-800">
                        <strong>入学審査について：</strong>学校によっては筆記テストや面談があります。英語が苦手なお子様でも挑戦できる学校が多く、万が一不合格でも別の学校を即座にご提案します。
                      </div>
                    )}
                    {i === 7 && (
                      <div className="mt-3 bg-purple-50 border border-purple-100 rounded-lg p-3 text-xs text-purple-800">
                        <strong>ビザについて：</strong>日本国籍は事前のビザ申請は不要です。現地到着後に外国人登録（IRP）を行い滞在許可を取得。入国審査時には<strong>「未成年者渡航同意書（親の署名原本）」</strong>が必須です。現地スタッフが全面サポートします。
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* ── TESTIMONIALS ── */}
      <section className="py-20 relative overflow-hidden" style={{ background: "linear-gradient(135deg, #fef9c3 0%, #d1fae5 55%, #cffafe 100%)" }}>
        {/* Decorative blobs */}
        <div className="absolute -top-16 -left-16 w-72 h-72 rounded-full bg-emerald-300/30 pointer-events-none" />
        <div className="absolute -bottom-12 -right-12 w-60 h-60 rounded-full bg-amber-300/35 pointer-events-none" />
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-96 h-96 rounded-full bg-teal-200/20 pointer-events-none" />
        <div className="absolute top-8 right-1/4 w-20 h-20 rounded-full bg-emerald-400/30 pointer-events-none" />
        <div className="absolute bottom-16 left-1/4 w-14 h-14 rounded-full bg-emerald-600/30 pointer-events-none" />

        <div className="max-w-5xl mx-auto px-6 relative z-10">
          <div className="text-center mb-12">
            <span className="text-emerald-600 text-sm font-semibold tracking-widest uppercase">Voices</span>
            <h2 className="text-3xl font-bold text-gray-800 mt-2" style={{ fontFamily: "'Noto Serif JP', serif" }}>
              高校留学体験者の声
            </h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {[
              {
                nickname: "R.Tさん", age: "高1（留学当時）→ 現在大学2年", school: "Sutton Park School / TY→シニアサイクル",
                comment: "TYから始めたことで学校生活にもホームステイにも自然に慣れることができました。シニアサイクルでは成績でクラストップを取ることも。帰国後はAO入試で大学に合格できました。",
                accent: "border-t-4 border-emerald-400",
                iconBg: "bg-emerald-100 text-emerald-600",
              },
              {
                nickname: "Y.Iさん", age: "中3（留学当時）→ 現在高3", school: "Dundalk Grammar School / ボーディング",
                comment: "最初は不安でしたが、ガーディアンの方が毎週面談してくれたので安心でした。寮生活を通じて自立心が育ち、英語力だけでなく人間的に大きく成長できたと感じています。",
                accent: "border-t-4 border-teal-400",
                iconBg: "bg-teal-100 text-teal-600",
              },
              {
                nickname: "A.Nさん", age: "高2（留学当時）→ 現在社会人", school: "John Scottus School / 1年間",
                comment: "John Scottus Schoolでの1年間は、人生を大きく変える経験でした。英語力はもちろん、多様な文化背景を持つ友人たちとの交流で視野が広がり、帰国後のキャリアにも確実に活きています。",
                accent: "border-t-4 border-amber-400",
                iconBg: "bg-amber-100 text-amber-600",
              },
            ].map((v, i) => (
              <div key={i} className={`bg-white rounded-xl p-5 ${v.accent}`}>
                <div className="text-4xl text-gray-100 font-serif leading-none mb-1 select-none">&ldquo;</div>
                <div className="flex items-center gap-3 mb-3">
                  <div className={`w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0 font-bold text-sm ${v.iconBg}`}>
                    {v.nickname.charAt(0)}
                  </div>
                  <div>
                    <div className="font-bold text-gray-800 text-sm">{v.nickname}</div>
                    <div className="text-xs text-gray-500 mt-0.5">{v.age}</div>
                  </div>
                </div>
                <div className="text-xs text-emerald-600 bg-emerald-50 px-2 py-1 rounded-full inline-block mb-3 border border-emerald-100">{v.school}</div>
                <p className="text-sm text-gray-600 leading-relaxed">{v.comment}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── FAQ ── */}
      <section className="py-20 bg-white">
        <div className="max-w-3xl mx-auto px-6">
          <div className="text-center mb-12">
            <span className="text-emerald-600 text-sm font-semibold tracking-widest uppercase">FAQ</span>
            <h2 className="text-3xl font-bold text-gray-800 mt-2" style={{ fontFamily: "'Noto Serif JP', serif" }}>
              高校留学よくある質問
            </h2>
          </div>
          <div className="space-y-3">
            {faqs.map((faq, i) => (
              <div key={i} className="bg-gray-50 rounded-lg border border-gray-100 overflow-hidden">
                <button
                  className="w-full flex items-center justify-between px-6 py-4 text-left cursor-pointer hover:bg-emerald-50 transition-colors"
                  onClick={() => setOpenFaq(openFaq === i ? null : i)}
                >
                  <div className="flex items-start gap-3">
                    <span className="w-6 h-6 flex items-center justify-center rounded-full bg-emerald-100 text-emerald-600 font-bold text-xs flex-shrink-0 mt-0.5">Q</span>
                    <span className="text-sm font-semibold text-gray-800">{faq.q}</span>
                  </div>
                  <span className="w-5 h-5 flex items-center justify-center text-emerald-500 flex-shrink-0 ml-3">
                    <i className={`${openFaq === i ? "ri-arrow-up-s-line" : "ri-arrow-down-s-line"} text-lg`} />
                  </span>
                </button>
                {openFaq === i && (
                  <div className="px-6 pb-4">
                    <div className="flex items-start gap-3">
                      <span className="w-6 h-6 flex items-center justify-center rounded-full bg-amber-100 text-amber-600 font-bold text-xs flex-shrink-0 mt-0.5">A</span>
                      <p className="text-sm text-gray-600 leading-relaxed">{faq.a}</p>
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── CONTACT ── */}
      <section id="hs-contact" className="py-20 bg-white">
        <div className="max-w-6xl mx-auto px-6">
          <div className="rounded-3xl shadow-2xl overflow-hidden relative border-2 border-gray-100">
            {/* Background */}
            <div className="absolute inset-0">
              <img
                alt="アイルランド高校留学相談"
                className="w-full h-full object-cover object-top"
                src="https://readdy.ai/api/search-image?query=Japanese%20family%20parents%20and%20teenage%20daughter%20smiling%20together%20looking%20at%20tablet%20planning%20study%20abroad%20program%20Ireland%20cozy%20bright%20home%20living%20room%20warm%20natural%20light%20representing%20family%20consultation%20for%20high%20school%20study%20abroad&width=1200&height=800&seq=hs-contact-cta-002&orientation=landscape"
              />
              <div className="absolute inset-0 bg-black/50" />
            </div>

            <div className="p-5 md:p-16 relative z-10">
              {/* Heading */}
              <div className="text-center mb-8 md:mb-12">
                <h2 className="text-xl md:text-4xl lg:text-5xl font-bold text-white mb-4 leading-tight" style={{ fontFamily: "'Noto Serif JP', serif" }}>
                  私たちと一緒に、<br />お子様の留学の夢を叶えましょう！
                </h2>
                <p className="text-base md:text-xl text-white/95 font-medium mb-2">
                  お問い合わせ、ご相談はLINEから！
                </p>
                <p className="text-xs pt-1">
                  ※電話番号: 0120-963-815
                </p>
              </div>

              <div className="grid md:grid-cols-2 gap-8 md:gap-12 items-center">
                {/* QR Code */}
                <div className="flex justify-center">
                  <div className="bg-white rounded-3xl p-5 md:p-8 inline-block shadow-xl border-2 border-gray-100">
                    <img
                      alt="LINE QR Code"
                      className="w-40 h-40 md:w-56 md:h-56 mx-auto mb-4 md:mb-6 object-contain"
                      src="https://static.readdy.ai/image/7e5541a56ec34f9c335c4f691557a0ff/e1baf93312b155fc04e26b58aedc7f5f.png"
                    />
                    <div className="text-center">
                      <img
                        alt="LINE Logo"
                        className="h-8 md:h-10 w-auto mx-auto"
                        src="https://cdn.prod.website-files.com/67f378cb597b81cc842aaf26/680e2e5d5d44931472ea7a55_LINE_LOGO.svg"
                      />
                    </div>
                  </div>
                </div>

                {/* Right: features + buttons */}
                <div className="space-y-4 md:space-y-6">
                  {[
                    { title: "無料の個別カウンセリング受付中！", sub: "お子様の年齢・英語レベル・ご予算に合わせてご提案" },
                    { title: "学校・プログラム資料も無料配布！", sub: "気になる学校の詳細情報をすぐにお届けします" },
                    { title: "手数料は一切かかりません！", sub: "ご相談から手続きまですべて無料でサポート" },
                  ].map((item) => (
                    <div key={item.title} className="flex items-start gap-3 text-white">
                      <div className="w-8 h-8 md:w-10 md:h-10 flex items-center justify-center bg-white/20 rounded-full flex-shrink-0">
                        <i className="ri-checkbox-circle-fill text-xl md:text-2xl" />
                      </div>
                      <div>
                        <p className="text-sm md:text-base font-bold mb-0.5">{item.title}</p>
                        <p className="text-xs md:text-sm text-white/80">{item.sub}</p>
                      </div>
                    </div>
                  ))}

                  <div className="text-center mb-1">
                    <p className="text-sm font-bold text-[#06C755]">
                      <i className="ri-gift-line text-base mr-1" />
                      \今なら特典もプレゼント!/
                    </p>
                  </div>
                  <a
                    href="https://lstep.app/N5D3BZr"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center justify-center gap-3 bg-[#06C755] text-white px-8 py-3.5 md:px-10 md:py-4 rounded-full font-bold text-sm md:text-base hover:bg-[#05b34c] transition-colors shadow-lg cursor-pointer whitespace-nowrap w-full"
                  >
                    <i className="ri-line-line text-xl md:text-2xl" />
                    LINE友だち追加
                  </a>

                  <div className="text-center mb-1">
                    <p className="text-sm font-bold text-emerald-300">
                      <i className="ri-time-line text-base mr-1" />
                      \簡単30秒!/
                    </p>
                  </div>
                  <Link
                    to="/counseling"
                    className="inline-flex items-center justify-center gap-3 bg-emerald-600 hover:bg-emerald-500 text-white px-8 py-3.5 md:px-10 md:py-4 rounded-full font-bold text-sm md:text-base transition-colors shadow-lg cursor-pointer whitespace-nowrap w-full"
                  >
                    <i className="ri-calendar-check-line text-xl md:text-2xl" />
                    無料カウンセリング予約
                  </Link>

                  <p className="text-center text-white/70 text-xs pt-1">
                    ※電話番号: 0120-963-815
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
